import React, { Fragment, useState } from "react";
import SideBar from "./SideBar";
import Header from "./Header";

const JobieNav = ({ title, onClick: ClickToAddEvent, onClick2, onClick3 }) => {
  const [toggle, setToggle] = useState("");
  const onClick = (name) => setToggle(toggle === name ? "" : name);
  return (
    <Fragment>
      <SideBar onClick={() => onClick2()} onClick3={() => onClick3()} />
      <Header
        onProfile={() => onClick("profile")}
        toggle={toggle}
        title={title}
        onBox={() => onClick("box")}
        onClick={() => ClickToAddEvent()}
      />
    </Fragment>
  );
};

export default JobieNav;
